export default __webpack_public_path__ + "static/media/incorrect-sound.c9e53d6b.wav";